import { all } from 'redux-saga/effects'

import { sessionTabsSaga } from '@tabeeb/modules/sessionTabs'
import { ContentSaga } from '@tabeeb/modules/shared/content'
import { GallerySagas } from '@tabeeb/modules/gallery'
import { permissionsSagas } from '@tabeeb/modules/permissions'
import { callNotificationSagas } from '@tabeeb/modules/callNotification'
import { remindersSagas } from '@tabeeb/modules/reminders'
import { discussionsSaga } from '@tabeeb/modules/discussion'
import { contentMetadataSaga } from '@tabeeb/modules/contentMetadata'
import { calendarSagas } from '@tabeeb/modules/calendar'
import { contentTrashBinSagas } from '@tabeeb/modules/contentTrashBin'

import { classificationAnnotationsPagesTimelineSagas } from '@tabeeb/modules/classificationAnnotationsPagesTimeline'
import { workflowSagas } from '@tabeeb/modules/workflows'
import { healthDataSagas } from '@tabeeb/modules/healthData'
import { mobileWhiteboardSagas } from '@tabeeb/modules/mobileWhiteboard'
import { aiReportSagas } from '@tabeeb/modules/aiReport'
import { powerBIReportProvidersSaga } from '@tabeeb/modules/powerBIReportProviders'
import watchRequest from './watchRequest'
import watchParallelRequests from './watchParallelRequests'
import watchUploadFiles from './watchUploadFiles'

import { accountSagas } from '../../modules/account'

import { RecordingSagas } from '../../modules/recording'
import { ActivitySagas } from '../../modules/activities'
import { FormsSagas } from '../../modules/forms'
import { PresentationSagas } from '../../modules/presentation'
import { PlayerToolbarSaga } from '../../modules/playerToolbar'
import { GridViewSagas } from '../../modules/gridView'

import { CustomVideoSagas } from '../../modules/customVideo'
import { PresentationToolbarSaga } from '../../modules/presentationToolbar'
import { usersSaga } from '../../users'
import { SessionsPageSagas } from '../../modules/sessionsPage'
import { chatSaga } from '../../modules/chat'
import { playerSagas } from '../../modules/player'
import { AnnotationsSagas } from '../../modules/annotations'
import { ArtificialIntelligenceSagas } from '../../modules/artificialIntelligence'
import { SpatialModelSagas } from '../../modules/spatialModel'
import { TenantSessionsSagas } from '../../modules/tenantSessionsPage'
import { ContentViewerSagas } from '../../modules/contentViewer'
import { PoliciesSagas } from '../../modules/policies'
import { ThreedeeModelSagas } from '../../modules/3dmodel'
import { ShareSessionPagesSagas } from '../../modules/shareSessionPagesList'
import { NotificationsPageSagas } from '../../modules/notificationsPage'
import { trackingSagas } from '../../modules/tracking'
import { ReviewSessionPagesSagas } from '../../modules/reviewSessionPagesList'
import { ContentReviewsSaga } from '../../modules/contentReviews'
import DevicesPageSaga from '../../modules/admin/devices/sagas'
import { compassSaga } from '../../modules/compass'
import { AnalyticsSaga } from '../../modules/powerBIReports'

import { appConfigStateSagas } from '../../modules/appConfigState'
import { signalrSagas } from '../../modules/signalr'
import { whiteboardSagas } from '../../modules/whiteboard'
import { BentleyModelSagas } from '../../modules/bentleyModel'
import { SplatModelSagas } from '../../modules/splatModel'
import { BentleyAnalyticsReportSagas } from '../../modules/bentleyAnalyticsReport'
import { ContentSharingsSaga } from '../../modules/contentSharings'
import modelTrainingSagas from '../../modules/modelTraining/sagas'

function* rootSaga() {
  yield all([
    watchRequest(),
    watchParallelRequests(),
    watchUploadFiles(),
    accountSagas(),
    sessionTabsSaga(),
    ContentSaga(),
    GallerySagas(),
    RecordingSagas(),
    ActivitySagas(),
    FormsSagas(),
    PresentationSagas(),
    PlayerToolbarSaga(),
    CustomVideoSagas(),
    PresentationToolbarSaga(),
    chatSaga(),
    usersSaga(),
    SessionsPageSagas(),
    playerSagas(),
    AnnotationsSagas(),
    ArtificialIntelligenceSagas(),
    SpatialModelSagas(),
    TenantSessionsSagas(),
    PoliciesSagas(),
    ContentViewerSagas(),
    ThreedeeModelSagas(),
    ShareSessionPagesSagas(),
    NotificationsPageSagas(),
    whiteboardSagas(),
    appConfigStateSagas(),
    signalrSagas(),
    trackingSagas(),
    ReviewSessionPagesSagas(),
    ContentReviewsSaga(),
    DevicesPageSaga(),
    AnalyticsSaga(),
    compassSaga(),
    permissionsSagas(),
    remindersSagas(),
    discussionsSaga(),
    callNotificationSagas(),
    GridViewSagas(),
    contentMetadataSaga(),
    calendarSagas(),
    contentTrashBinSagas(),
    healthDataSagas(),
    mobileWhiteboardSagas(),
    BentleyModelSagas(),
    SplatModelSagas(),
    BentleyAnalyticsReportSagas(),
    ContentSharingsSaga(),
    modelTrainingSagas(),
    aiReportSagas(),
    classificationAnnotationsPagesTimelineSagas(),
    powerBIReportProvidersSaga(),
    workflowSagas(),
  ])
}

export default rootSaga
